import { getContext } from '@/context';

export enum SdkEventType {
  OpenRegistrationScreen = 'OpenRegistrationScreen',
  OpenOfferScreen = 'OpenOfferScreen',
}

type PublishSdkEventParams = {
  event: SdkEventType;
  data?: Record<string, unknown>;
};

const publishSdkEvent = ({ event, data = {} }: PublishSdkEventParams): void => {
  try {
    getContext().handlers.publishEvent({ event, data });
  } catch {
    // Silent fail - SDK event publishing is non-critical
  }
};

export default publishSdkEvent;
